import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataCertificates } from 'store/ducks/Reportings/types';
import { certificateColumns } from 'components/Columns/CertificateForICtServiceColumns';

interface reportDataProps {
  entityName: string;
}

const CertificatesByICTServices: React.FC<reportDataProps> = ({
  entityName,
}) => {
  const { date, is_additional_displayed, ictService_id } = useSelector(
    (state: RootState) => state.reportings,
  );
  const [data, setData] = useState<DataCertificates[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      ict_service_id: ictService_id,
      date,
    };

    try {
      const fetchedData =
        await reportingOp.fetchCertificatesByICTServices(params);
      if (fetchedData && Array.isArray(fetchedData.certificates)) {
        const formattedData = fetchedData.certificates.map(
          (dataItem: any, index: number) => ({
            key: index,
            certificate_registry: dataItem.certificate_registry,
            date_of_certificate_register: dataItem.date_of_certificate_register,
            date_of_issuance: dataItem.date_of_issuance,
            description: dataItem.description,
            end_date: dataItem.end_date,
            function_id: dataItem.function_id,
            ict_service_id: dataItem.ict_service_id,
            ict_service_name: dataItem.ict_service_name,
            id: dataItem.id,
            start_date: dataItem.start_date,
            third_party_service_provider_id:
              dataItem.third_party_service_provider_id,
            validity: dataItem.validity,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (ictService_id) {
      fetchData();
    }
  }, [is_additional_displayed, ictService_id]);

  return (
    <>
      <Table
        columns={certificateColumns}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default CertificatesByICTServices;
